function initiateAnimations() {
    let elements;
    let windowHeight; 
    const wrapperElem = document.getElementsByClassName("animated-iwt--wrapper");
    let animationRan = false;
    function init() {
        elements = document.querySelectorAll(".animate");
        windowHeight = window.innerHeight;
    };
    function checkElemPosition() {
        let animationControl = 0.5;

        if(!!wrapperElem[0]) {
            animationControl = (wrapperElem[0].dataset.animationControl) / 100;
        };
        
        for (let i = 0; i < elements.length; i++) {
            let element = elements[i];
            if(animationRan == false) {
                element.style.visibility = "hidden";
            }
            let animateClass = element.dataset.animateClass;
            let positionFromTop = elements[i].getBoundingClientRect().top;
            const control = animationControl; 
            if( (windowHeight - positionFromTop) >= windowHeight * control ) {
                animationRan = true;
                element.classList.add(animateClass);
                element.style.opacity = 1;
            };
        };

    };  
    window.addEventListener("scroll", checkElemPosition);
    window.addEventListener("resize", init);
    init();
    checkElemPosition();
};

initiateAnimations();